<template>
  <div class="settlements-list-container">
    <!-- 顶部标题栏 -->
    <div class="page-header">
      <div class="header-title">
        <div class="title-mark"></div>
        <span>结算列表</span>
      </div>
    </div>
    
    <!-- Tab和搜索区域容器 -->
    <div class="tabs-search-container">
      <!-- Tab切换 -->
      <el-tabs v-model="activeTab" @tab-click="handleTabChange" class="settlement-tabs">
        <el-tab-pane label="销售结算" name="sales"></el-tab-pane>
        <el-tab-pane label="采购结算" name="purchase"></el-tab-pane>
      </el-tabs>
    
    <!-- 搜索区域 -->
    <div class="search-area">
      <el-input
        v-model="searchParams.settlement_no"
        placeholder="结算单号"
        clearable
        class="search-input"
        prefix-icon="el-icon-search"
      ></el-input>
      
      <el-input
        v-model="searchParams.settlement_title"
        placeholder="结算标题"
        clearable
        class="search-input"
        prefix-icon="el-icon-search"
      ></el-input>
      
      <el-select v-model="searchParams.status" placeholder="结算状态" clearable class="search-input">
        <el-option label="供应商待审核" value="DRAFT"></el-option>
        <el-option label="待确认" value="ACTIVE"></el-option>
        <el-option label="已确认" value="EXECUTING"></el-option>
        <el-option label="已开票" value="INVOICED"></el-option>
        <el-option label="结算完成" value="FINISHED"></el-option>
      </el-select>
      
      <el-date-picker
        v-model="searchParams.startDate"
        type="date"
        placeholder="查询时间起"
        aria-label="查询时间起"
        value-format="yyyy-MM-dd"
        clearable
        class="search-input"
      ></el-date-picker>
      <el-date-picker
        v-model="searchParams.endDate"
        type="date"
        placeholder="查询时间止"
        aria-label="查询时间止"
        value-format="yyyy-MM-dd"
        clearable
        class="search-input"
      ></el-date-picker>
      
      <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
    </div>
    </div>
    
    <!-- 结算列表 -->
    <el-table
      :data="settlementList"
      border
      style="width: 100%"
      v-loading="loading"
      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
    >
      <el-table-column
        label="结算单号"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.settlementNumber || scope.row.settlement_no || '-' }}
        </template>
      </el-table-column>
      
      <el-table-column
        label="结算标题"
        min-width="200"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.settlementTitle || scope.row.settlement_title || '-' }}
        </template>
      </el-table-column>
      
      <el-table-column
        label="结算时间"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          {{ formatDateTime(scope.row.settlementDate) }}
        </template>
      </el-table-column>
      
      <el-table-column
        prop="settlement_amount"
        label="结算金额"
        width="120"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.settlement_amount !== undefined && scope.row.settlement_amount !== null">
            {{ formatAmount(scope.row.settlement_amount) }}
          </span>
          <span v-else-if="scope.row.amount !== undefined && scope.row.amount !== null">
            {{ formatAmount(scope.row.amount) }}
          </span>
          <span v-else>{{ formatAmount(0) }}</span>
        </template>
      </el-table-column>
      
      <el-table-column
        prop="status"
        label="结算状态"
        width="120"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag :type="getStatusTagType(scope.row.status)">
            {{ getStatusText(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      
      <el-table-column
        label="创建时间"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          {{ formatDate(scope.row.createTime || scope.row.create_time) }}
        </template>
      </el-table-column>
      
      <el-table-column
        label="关联产品"
        width="200"
        align="center"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.settlementItems && scope.row.settlementItems.length > 0">
            <el-popover
              placement="top"
              width="400"
              trigger="hover"
            >
              <div v-for="(item, index) in scope.row.settlementItems" :key="index" style="margin-bottom: 8px;">
                <p class="product-item">
                  <span class="product-name">{{ item.productName || item.materialsName || item.itemProductName || '未知产品' }}</span>
                  <span class="product-spec">
                    <el-tooltip
                      v-if="getSpecificationText(item)"
                      :content="getSpecificationText(item)"
                      placement="top"
                      effect="dark"
                      popper-class="spec-tooltip"
                    >
                      <span>{{ truncateText(getSpecificationText(item), 20) }}</span>
                    </el-tooltip>
                    <span v-else>-</span>
                  </span>
                  <span class="product-quantity">{{ item.settledQuantity || 0 }} {{ item.unit || item.itemUnit || '个' }}</span>
                  <span class="product-amount">{{ formatAmount(item.totalAmount || item.settledAmount || 0) }}</span>
                </p>
              </div>
              <div slot="reference" class="products-summary" @click="viewRelatedProducts(scope.row.settlementItems)">
                {{ scope.row.settlementItems.length }}个产品
              </div>
            </el-popover>
          </div>
          <span v-else>-</span>
        </template>
      </el-table-column>
      
      <el-table-column
        label="操作"
        width="280"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="viewDetail(scope.row.id)"
          >查看</el-button>
          
          <el-button
            v-if="(scope.row.status === 'DRAFT' || scope.row.status === 'ACTIVE') && isCreator(scope.row)"
            v-permission="'settlement:settlements-list:delete'"
            type="danger"
            size="mini"
            @click="cancelSettlement(scope.row)"
          >删除</el-button>

          <!-- <el-button
            v-if="!scope.row.isForwarded"
            type="warning"
            size="mini"
            @click="forwardSettlement(scope.row)"
            icon="el-icon-share"
          >转发</el-button> -->

          <el-button
            v-permission="'settlement:settlements-list:view-attachments'"
            type="success"
            size="mini"
            @click="manageAttachments(scope.row.id)"
            icon="el-icon-paperclip"
          >附件管理</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.current"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </div>
    
    <!-- 关联产品弹窗 -->
    <el-dialog
      v-dialog-drag
      title="关联产品列表"
      :visible.sync="relatedProductsDialogVisible"
      width="80%"
      @close="closeRelatedProductsDialog"
    >
      <el-table
        :data="relatedProductsList"
        v-loading="relatedProductsLoading"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column
          label="产品名称"
          min-width="150"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.productName || scope.row.materialsName || scope.row.itemProductName || '未知产品' }}
          </template>
        </el-table-column>
        
        <el-table-column
          label="规格型号"
          min-width="120"
          align="center"
        >
          <template slot-scope="scope">
            <el-tooltip
              v-if="getSpecificationText(scope.row)"
              :content="getSpecificationText(scope.row)"
              placement="top"
              effect="dark"
              popper-class="spec-tooltip"
            >
              <span>{{ truncateText(getSpecificationText(scope.row), 20) }}</span>
            </el-tooltip>
            <span v-else>-</span>
          </template>
        </el-table-column>
        
        <el-table-column
          label="材质要求"
          min-width="120"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.materialRequirement || scope.row.itemMaterialRequirement || '-' }}
          </template>
        </el-table-column>
        
        <el-table-column
          label="结算数量"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.settledQuantity || 0 }} {{ scope.row.unit || scope.row.itemUnit || '个' }}
          </template>
        </el-table-column>
        
        <el-table-column
          label="发货日期"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            {{ formatDate(scope.row.itemShipmentDate) }}
          </template>
        </el-table-column>
        
        <el-table-column
          label="单价"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            {{ formatUnitPrice(scope.row.unitPrice || 0) }}
          </template>
        </el-table-column>
        
        <el-table-column
          label="税率"
          min-width="80"
          align="center"
        >
          <template slot-scope="scope">
            {{ ((scope.row.taxRate || scope.row.itemTaxRate || scope.row.product_tax_rate || 0) * 100).toFixed(1) }}%
          </template>
        </el-table-column>
        
        <el-table-column
          label="结算金额"
          min-width="120"
          align="center"
        >
          <template slot-scope="scope">
            {{ formatAmount(scope.row.totalAmount || scope.row.settledAmount || 0) }}
          </template>
        </el-table-column>
        
        <el-table-column
          label="备注"
          min-width="120"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.remark || '-' }}
          </template>
        </el-table-column>
      </el-table>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeRelatedProductsDialog">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  search_sales_settlements_pagination,
  search_purchase_settlements_pagination,
  delete_settlement
} from '@/api/modules/settlement'

export default {
  name: 'SettlementsList',
  data() {
    return {
      activeTab: 'sales', // 默认显示销售结算
      // 搜索参数
      searchParams: {
        settlement_no: '',
        settlement_title: '',
        status: '',
        startDate: '',
        endDate: ''
      },
      // 表格加载状态
      loading: false,
      // 结算列表数据
      settlementList: [],
      // 分页参数
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      // 当前用户ID
      currentUserId: null,
      // 关联产品弹窗
      relatedProductsDialogVisible: false,
      relatedProductsList: [],
      relatedProductsLoading: false
    };
  },
  created() {
    // 恢复上次保存的tab状态
    const savedTab = sessionStorage.getItem('settlements_active_tab');
    if (savedTab) {
      this.activeTab = savedTab;
    }
    // 获取当前用户ID
    this.getCurrentUserId();
    // 初始加载数据
    this.getSettlementList();
  },
  methods: {
    // 获取规格型号文本
    getSpecificationText(item) {
      if (!item) return '';
      return (
        item.specification ||
        item.materialsSpec ||
        item.itemSpecification ||
        item.productSpecification ||
        ''
      );
    },

    // 截断文本显示，默认为20个字符
    truncateText(text, length = 20) {
      if (!text) return '-';
      const str = String(text);
      return str.length > length ? `${str.slice(0, length)}...` : str;
    },

    // 格式化金额（带千位分隔符）
    formatAmount(amount) {
      if (amount === undefined || amount === null) return '0.00';
      return Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    // 格式化单价（固定保留5位小数）
    formatUnitPrice(amount) {
      if (amount === undefined || amount === null) return '0.00000';
      const num = Number(amount);
      return isNaN(num) ? '0.00000' : num.toFixed(5);
    },

    // 获取当前用户ID
    getCurrentUserId() {
      try {
        const store = this.$store || {};
        const state = store.state || {};
        
        let userInfo = null;
        
        if (state.user && state.user.userInfo) {
          userInfo = state.user.userInfo;
        } else if (state.userInfo) {
          userInfo = state.userInfo;
        } else if (state.auth && state.auth.userInfo) {
          userInfo = state.auth.userInfo;
        }
        
        if (!userInfo || (!userInfo.id && !userInfo.userId)) {
          const localUserInfo = localStorage.getItem('userInfo');
          if (localUserInfo) {
            try {
              userInfo = JSON.parse(localUserInfo);
            } catch (e) {
              console.error('解析localStorage中的userInfo失败:', e);
            }
          }
        }
        
        if (userInfo && (userInfo.id || userInfo.userId)) {
          this.currentUserId = userInfo.id || userInfo.userId;
        } else {
          this.currentUserId = null;
        }
      } catch (err) {
        console.error('获取用户ID出错:', err);
        this.currentUserId = null;
      }
    },
    
    // 检查当前用户是否是结算单创建人
    isCreator(settlement) {
      if (!settlement || !this.currentUserId) {
        return false;
      }
      
      // 兼容多种可能的创建人ID字段名
      const creatorId = settlement.creatorId || settlement.creator_id || settlement.createId || settlement.create_id;
      
      if (!creatorId) {
        return false;
      }
      
      // 使用 == 进行宽松比较，兼容字符串和数字类型
      return creatorId == this.currentUserId || creatorId === this.currentUserId;
    },
    
    // Tab切换处理
    handleTabChange() {
      this.pagination.current = 1;
      sessionStorage.setItem('settlements_active_tab', this.activeTab);
      this.getSettlementList();
    },
    
    // 获取结算列表
    getSettlementList() {
      const { startDate, endDate } = this.searchParams;
      if (startDate && endDate && startDate > endDate) {
        this.$message.warning('查询时间起不能晚于查询时间止');
        return;
      }
      this.loading = true;
      
      // 构建查询参数，参考 API 文档 v4.13 格式
      const params = {
        page: this.pagination.current - 1, // API 使用 0 基页码
        size: this.pagination.pageSize,
        sortBy: 'id',
        sortDir: 'desc'
      };
      
      // 结算编号、标题（模糊查询）
      if (this.searchParams.settlement_no) {
        params.settlementNumber = this.searchParams.settlement_no;
      }
      
      if (this.searchParams.settlement_title) {
        params.settlementTitle = this.searchParams.settlement_title;
      }
      
      if (this.searchParams.status) {
        params.status = this.searchParams.status;
      }
      
      // 日期范围（yyyy-MM-dd 格式）
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;
      
      const searchApi = this.activeTab === 'sales'
        ? search_sales_settlements_pagination
        : search_purchase_settlements_pagination;
      
      searchApi(params)
        .then(response => {
          if (response.data && response.data.success) {
            let data = response.data.data || {};
            
            // 处理新API的响应格式
            if (data.content && Array.isArray(data.content)) {
              // 新API返回的分页格式
              this.settlementList = data.content;
              this.pagination.total = data.totalElements || 0;
              this.pagination.current = (data.number || 0) + 1; // 转换为1基页码
            } else if (data.list && Array.isArray(data.list)) {
              this.settlementList = data.list;
              this.pagination.total = data.total || 0;
              
              if (data.page) {
                this.pagination.current = data.page;
              }
            } else if (Array.isArray(data)) {
              this.settlementList = data;
              this.pagination.total = data.length;
            } else if (data.records && Array.isArray(data.records)) {
              this.settlementList = data.records;
              this.pagination.total = data.total || 0;
            } else if (data.data && Array.isArray(data.data)) {
              this.settlementList = data.data;
              this.pagination.total = data.total || 0;
            } else {
              console.error('意外的结算数据结构:', data);
              this.$message.error('获取结算列表失败：数据格式错误');
              this.settlementList = [];
              this.pagination.total = 0;
            }
            
            this.settlementList = this.settlementList.map(item => {
              const standardItem = { ...item };
              
              if (standardItem.settlement_amount === undefined && standardItem.amount !== undefined) {
                standardItem.settlement_amount = standardItem.amount;
              }
              
              if (!standardItem.period_start && standardItem.start_date) {
                standardItem.period_start = standardItem.start_date;
              }
              if (!standardItem.period_end && standardItem.end_date) {
                standardItem.period_end = standardItem.end_date;
              }
              
              // 确保settlement_orders数组存在
              if (!standardItem.settlement_orders) {
                standardItem.settlement_orders = [];
                
                // 如果有单个order对象，将其转换为settlement_orders格式
                if (standardItem.order) {
                  standardItem.settlement_orders.push({
                    order_id: standardItem.order.id || standardItem.order_id,
                    order: standardItem.order,
                    settlement_amount: standardItem.settlement_amount
                  });
                }
              }
              
              // 调试信息：打印结算数据结构
return standardItem;
            });
          } else {
            console.error('获取结算列表失败:', response.data?.message);
            this.$message.error(response.data?.message || '获取结算列表失败');
            this.settlementList = [];
            this.pagination.total = 0;
          }
          this.loading = false;
        })
        .catch(error => {
          console.error('获取结算列表请求错误:', error);
          this.$message.error('获取结算列表失败，请稍后重试');
          this.settlementList = [];
          this.pagination.total = 0;
          this.loading = false;
        });
    },
    
    // 搜索
    handleSearch() {
      this.pagination.current = 1;
      
      this.getSettlementList();
    },
    
    // 页码改变
    handleCurrentChange(currentPage) {
      this.pagination.current = currentPage;
      this.getSettlementList();
    },
    
    // 每页条数改变
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.current = 1;
      this.getSettlementList();
    },
    
    // 根据状态获取Tag类型
    getStatusTagType(status) {
      if (!status) return 'info';
      
      switch (status) {
        case 'ACTIVE':
          return 'info';
        case 'EXECUTING':
          return 'warning';
        case 'INVOICED':
          return 'primary';
        case 'FINISHED':
          return 'success';
        case 'CANCELLED':
          return 'danger';
        default:
          return 'info';
      }
    },
    
    // 获取状态显示文本
    getStatusText(status) {
      if (!status) return '-';
      
      switch (status) {
        case 'DRAFT':
          return '供应商待审核';
        case 'ACTIVE':
          return '待确认';
        case 'EXECUTING':
          return '已确认';
        case 'INVOICED':
          return '已开票';
        case 'FINISHED':
          return '结算完成';
        default:
          return status;
      }
    },
    
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '-';
      
      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
          if (typeof dateString === 'string') {
            const parts = dateString.split('-');
            if (parts.length === 3) {
              return dateString;
            }
          }
          return dateString || '-';
        }
        
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      } catch (e) {
        console.error('日期格式化错误:', e);
        return dateString || '-';
      }
    },
    
    // 格式化日期时间
    formatDateTime(dateString) {
      if (!dateString) return '-';
      
      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
          return dateString || '-';
        }
        
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        
        return `${year}-${month}-${day} ${hours}:${minutes}`;
      } catch (e) {
        console.error('日期时间格式化错误:', e);
        return dateString || '-';
      }
    },
    
    // 查看详情
    viewDetail(id) {
      this.$router.push(`/settlement/settlement-detail/${id}`);
    },
    
    // 删除结算
    cancelSettlement(settlement) {
      // 验证状态：只有待审核（DRAFT）和待确认（ACTIVE）状态可以删除
      if (settlement.status !== 'DRAFT' && settlement.status !== 'ACTIVE') {
        this.$message.warning('只有待审核和待确认状态的结算单可以删除');
        return;
      }
      
      // 验证创建人：只有创建人才能删除
      if (!this.isCreator(settlement)) {
        this.$message.warning('只能删除自己创建的结算单');
        return;
      }
      
      this.$confirm('确认删除该结算单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delete_settlement(settlement.id)
          .then(response => {
            if (response.data && response.data.success) {
              this.$message.success('删除成功');
              this.getSettlementList();
            } else {
              this.$message.error(response.data?.message || '删除失败');
            }
          })
          .catch(error => {
            console.error('删除结算失败:', error);
            const errorMessage = error.response?.data?.message || error.message || '删除失败，请稍后重试';
            this.$message.error(errorMessage);
          });
      }).catch(() => {
        // 用户取消操作
      });
    },
    
    
    
    // 查看关联产品
    viewRelatedProducts(settlementItems) {
      if (!settlementItems || settlementItems.length === 0) {
        this.$message.warning('没有关联的产品');
        return;
      }
      
      this.relatedProductsLoading = true;
      this.relatedProductsDialogVisible = true;
      this.relatedProductsList = settlementItems;
      this.relatedProductsLoading = false;
    },
    
    // 关闭关联产品弹窗
    closeRelatedProductsDialog() {
      this.relatedProductsDialogVisible = false;
      this.relatedProductsList = [];
    },
    
    // 管理附件
    manageAttachments(settlementId) {
      this.$router.push(`/settlement/attachments/${settlementId}`);
    },
    
    // 转发结算
    forwardSettlement(settlement) {
      this.$router.push({
        path: `/settlement/forward-settlement/${settlement.id}`,
        query: {
          settlementNumber: settlement.settlementNumber,
          settlementTitle: settlement.settlementTitle
        }
      });
    },
    
  }
};
</script>

<style lang="scss" scoped>
.settlements-list-container {
  padding: 20px;
  background-color: #fff;
  
  .page-header {
    margin-bottom: 20px;
    
    .header-title {
      display: flex;
      align-items: center;
      
      .title-mark {
        width: 4px;
        height: 18px;
        background-color: #2c73eb;
        margin-right: 8px;
      }
      
      span {
        font-size: 18px;
        font-weight: 500;
        color: #303133;
      }
    }
  }
  
  .tabs-search-container {
    background-color: #fff;
    border-radius: 4px;
    margin-bottom: 20px;
    overflow: hidden;
  }

  .settlement-tabs {
    padding: 0 20px;
    margin-bottom: 0;
  }

  .search-area {
    padding: 20px;
    padding-top: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    
    .search-input {
      width: 220px;
      margin-right: 15px;
      margin-bottom: 10px;
    }
    
    .el-button {
      margin-bottom: 10px;
    }
  }
  
  .pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
  
  .el-table {
    margin-bottom: 20px;
  }
  
  .products-summary {
    color: #409EFF;
    cursor: pointer;
    text-decoration: underline;
  }
  
  .product-item {
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 4px 0;
    border-bottom: 1px dashed #EBEEF5;
    
    &:last-child {
      border-bottom: none;
    }
    
    .product-name {
      font-weight: bold;
      margin-bottom: 2px;
    }
    
    .product-spec {
      color: #909399;
      font-size: 12px;
      margin-bottom: 2px;
    }
    
    .product-quantity {
      color: #67C23A;
      font-size: 12px;
      margin-bottom: 2px;
    }
    
    .product-amount {
      color: #E6A23C;
      font-weight: bold;
      font-size: 12px;
    }
  }
}
</style>

<style lang="scss">
.spec-tooltip {
  max-width: 600px !important;
  white-space: normal;
  word-break: break-all;
}
</style>
